import styled from '@emotion/styled/macro';
import { Link } from 'gatsby';
import React from 'react';
import { Highlight, Snippet } from 'react-instantsearch';
import { GTM_ID } from '../../../../../common/constants/gtmIds';
import { H4Atom, PAtom, PillAtom } from '../../../atoms/text-atoms/text-atoms';
import { generateKey } from '../../../utils/utils';
import vars from '../../../variables';

const RHSearchResult = ({ hit, sendEvent }) => {
  const onClick = () => {
    sendEvent('click', hit, 'Article Clicked');
  };

  return (
    <StyledRHSearchResult onClick={() => onClick()}>
      <Link to={hit.url} data-gtm-id={GTM_ID.SEARCH_RESULT}>
        {hit.file && (
          <div className="img-wrap">
            <img src={hit.file.url} alt={hit.listingTitle} />
          </div>
        )}
        <div className="text-wrap">
          <H4Atom>
            <Highlight
              attribute="listingTitle"
              hit={hit}
              highlightedTagName="mark"
            />
          </H4Atom>
          {hit.listingDescription !== undefined ? (
            <PAtom>
              <Snippet
                attribute="listingDescription"
                hit={hit}
                highlightedTagName="mark"
              />
            </PAtom>
          ) : null}
          {hit.flexibleContent !== undefined ? (
            <PAtom>
              <Snippet
                attribute="flexibleContent"
                hit={hit}
                highlightedTagName="mark"
              />
            </PAtom>
          ) : null}
          {hit.pdfContent !== undefined ? (
            <PAtom>
              <Snippet
                attribute="pdfContent"
                hit={hit}
                highlightedTagName="mark"
              />
            </PAtom>
          ) : null}
          {(hit.topics || hit.resourceContentType || hit.geography) && (
            <div className="topics-wrap">
              <ul>
                {hit.topics &&
                  hit.topics.map((topic, index) => (
                    <PillAtom key={generateKey(topic.title, index)}>
                      {topic.title}
                    </PillAtom>
                  ))}
                {hit.resourceContentType &&
                  hit.resourceContentType.map((resource, index) => (
                    <PillAtom key={generateKey(resource.title, index)}>
                      {resource.title}
                    </PillAtom>
                  ))}
                {hit.geography &&
                  hit.geography.map((location, index) => (
                    <PillAtom key={generateKey(location.title, index)}>
                      {location.title}
                    </PillAtom>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </Link>
    </StyledRHSearchResult>
  );
};

const StyledRHSearchResult = styled.div`
  a {
    display: block;
    padding: ${vars.spacingL};
    border: none;
    box-sizing: border-box;
    text-decoration: none;
  }
  a:hover {
    cursor: pointer;
    background: ${vars.greyHavens};
  }
  a:after {
    clear: both;
    display: block;
    content: ' ';
  }
  .img-wrap {
    position: relative;
    margin-right: ${vars.spacingL};
    margin-bottom: ${vars.spacingL};
    min-width: 100%;
    width: 100%;
    height: 15.6rem;
    overflow: hidden;
  }
  .img-wrap img {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
  }
  .text-wrap {
    max-width: 100%;
    width: 100%;
  }
  .text-wrap h4 {
    padding-bottom: 0;
  }
  .text-wrap h4 span {
    ${vars.fontSize5}
    font-weight: ${vars.fontWeightBold};
    line-height: 1.5;
    letter-spacing: -0.02em;
  }
  .text-wrap li {
    margin-top: ${vars.spacingS};
  }
  .text-wrap li:not(:last-of-type) {
    margin-right: ${vars.spacingM};
  }
  .text-wrap p {
    ${vars.fontSize2}
    line-height: 1.35;
  }
  .topics-wrap {
    display: flex;
    align-items: center;
  }
  .topics-wrap p {
    margin-right: 15px;
  }
  .topics-wrap ul {
    padding-bottom: 10px;
  }
  .ais-Highlight-highlighted {
    font-weight: ${vars.fontWeightBold};
    background-color: ${vars.borderGrey};
    color: ${vars.coreDarkGrey};
  }
  .ais-Snippet-highlighted {
    background-color: ${vars.borderGrey};
    color: ${vars.coreDarkGrey};
  }
  @media screen and (min-width: ${vars.breakPointSmallTablet}) {
    a {
      display: flex;
    }
    .img-wrap {
      width: 27.7rem;
      min-width: 27.7rem;
      margin-bottom: 0;
    }
  }
`;

export default RHSearchResult;
